const global_settings = {
  fields_tab: 'User custom fields',
  code_length: 'Keypad code length',
  min_length: 'Minimum length',
  max_length: 'Maximum length',
  keypad_confirmation_msg:
    'Are you sure you want to change the keypad code length from {{ initialKeypadCode }} to {{ keypadCode }}?',
  keypad_var_confirmation_msg:
    'Are you sure you want to change the minimum and maximum keypad code length?',
  field_label: 'Field label',
  field_type: 'Field type',
  fields_confirmation_msg:
    'Are you sure you want to save the changes? Any deletion of custom fields will affect users that had them.',
  fields_delete_msg:
    'Are you sure you want to delete this custom field? It has been assigned to {{user_count}} users.',
  fields_success: 'Custom fields saved successfully',
  keypad_success: 'Update completed successfully',
  keypad_error: 'Error while updating',
  keypad_exists:
    'There are users with keypad code, modifications will be limited.',
  add_new_field: 'Add new field',
  no_fields_configured: 'There are no custom fields configured.',
  all_fields_removed: 'All fields removed. Save to apply these changes.',
};

export default global_settings;
